import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'
import { Close } from 'components/lib/DesignSystem/Icons'
import PopupMessage from 'components/lib/DesignSystem/PopupMessage'

const mapBackgroundColorByType = {
  info: '#0091FF', // blue
  error: '#E44258', // red
  warning: '#FA6400', // orange
  success: 'rgb(51,178,0)', // green
}

class ToastsContainerItem extends React.Component {
  TIME_TO_DISAPPEAR = 5000

  mapImgByType = {
    info: '/static/webapp/images/toast-info.svg',
    error: '/static/webapp/images/toast-error.svg',
    success: '/static/webapp/images/toast-info.svg',
    warning: '/static/webapp/images/toast-error.svg',
  }

  componentDidMount() {
    this.scheduleHideTimeout()
    const modalCloseIcon = document.getElementById('x-modal_close')
    if (modalCloseIcon) modalCloseIcon.click()
  }

  componentWillUnmount() {
    clearInterval(this.timerId)
  }

  scheduleHideTimeout = () => {
    const { timeToDisappear } = this.props
    this.timerId = setTimeout(() => {
      if (document.hidden) this.scheduleHideTimeout()
      else this.props.removeToast(this.props.nId)
    }, timeToDisappear || this.TIME_TO_DISAPPEAR)
  }

  handlerOnClick = () => {
    const { nId, removeToast } = this.props
    removeToast(nId)
  }

  render() {
    const { className, message, type, button, id } = this.props

    return (
      <div id={id} className={className}>
        <div className="img-container mr">
          <img src={this.mapImgByType[type]} />
        </div>
        <div className="toasts-container">
          <Close
            width="22px"
            height="22px"
            onClick={this.handlerOnClick}
            style={{ position: 'absolute', right: '0' }}
            fill="#fff"
          />
          <span className="message-container">{message}</span>
          {button && (
            <Button
              id={button.id}
              onClick={() => {
                if (typeof button?.onClick === 'function') {
                  button.onClick()
                }
                this.handlerOnClick()
              }}
              text={button?.text}
              style={{
                lineHeight: '14px',
                background: 'transparent',
                border: '1px solid #fff',
                borderRadius: '4px',
              }}
            />
          )}
        </div>
      </div>
    )
  }
}

function ToastsContainer({ className, toasts, removeToast, history }) {
  if (!toasts.length) return ''

  return (
    <div className={className}>
      {toasts.map((elem) => (
        <>
          {elem.ds ? (
            <PopupMessage
              key={elem.id}
              className={elem.className}
              cover={elem.cover}
              title={elem.title}
              message={elem.message}
              boldInMessage={elem.boldInMessage}
              onClose={() => removeToast(elem.id)}
              ctaText={elem.ctaText}
              ctaOnClick={(e) => {
                if (elem.ctaInternalRedirect) {
                  history.push(elem.ctaInternalRedirect)
                }
                removeToast(elem.id)
              }}
            />
          ) : (
            <StyledToastsContainerItem
              key={elem.id}
              id={elem.id}
              nId={elem.id}
              message={elem.message}
              button={elem.button}
              removeToast={removeToast}
              timeToDisappear={elem.timeToDisappear}
              type={elem.type || 'success'}
            />
          )}
        </>
      ))}
    </div>
  )
}

const StyledToastsContainer = styled(ToastsContainer)`
  position: fixed;
  right: 40px;
  bottom: 40px;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  z-index: 1005;
  & > *:not(:first-child) {
    margin-bottom: 20px;
  }
`

const StyledToastsContainerItem = styled(ToastsContainerItem)`
  width: ${(props) => props.width || '360px'};
  padding: 15px 15px 15px 52px;
  border-radius: 6px;
  background-color: ${(props) => mapBackgroundColorByType[props.type]};
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-out;
  position: relative;
  img {
    width: 22px;
    margin-right: 15px;
    position: absolute;
    top: 15px;
    left: 15px;
  }
  .toasts-container {
    color: white;
    padding: 0;
    position: relative;
    word-wrap: break-word;
    & > * {
      display: inline-block;
      vertical-align: middle;
      &.tm-icon {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .img-container {
      width: 20px;
    }
    .message-container {
      width: calc(100% - 55px);
    }
  }
`

export default withRouter(StyledToastsContainer)
